const _ = require('lodash');

const deps = [];

const factory = ($timeout, $q) => {
  let totalNotifications = 0;

  class Notifications {
    constructor() {
      this.remove = this.remove.bind(this);
    }

    remove(id) {
      const index = _.findIndex(this.notifications, { id });

      if (index > -1) {
        return this.notifications.splice(index, 1);
      }
    }

    add(text, setOptions = {}) {
      const id = totalNotifications++;

      // Set default options
      const options = _.defaults(setOptions, {
        length: 5,
        type: 'default',
        percent: 0,
        actionText: '',
      });

      if (options.length > 0) {
        options.timeout = $timeout(() => this.remove(id), options.length * 1000);
      }

      this.notifications.push(_.extend(options, { id, text }));

      return id;
    }

    modify(id, text, setOptions = {}) {
      const index = _.findIndex(this.notifications, { id });
      const notification = _.extend(this.notifications[index], setOptions, { text });

      if (notification.timeout != null) {
        $timeout.cancel(notification.timeout);
      }

      if ((setOptions.length != null) > 0) {
        notification.timeout = $timeout(() => this.remove(id), setOptions.length * 1000);
      }

      return (this.notifications[index] = notification);
    }

    loader(setOptions) {
      // Default options
      const options = _.defaults(setOptions, {
        loadingText: 'Saving data...',
        successText: 'Data saved.',
        failureText: 'Data failed to save.',
        useServerFailMessage: false,
        minLoadTime: 1,
      }); // Second

      const notification = this.add(options.loadingText, { type: 'loading' });

      // Wait the minimum load time before changing
      return $q(resolve => $timeout(resolve, options.minLoadTime * 1000))
        .then(() => options.resolve)
        .then(res => {
          this.modify(notification, options.successText, {
            type: 'success',
            length: 3,
          });
          return res;
        })
        .catch(err => {
          const failureText = options.useServerFailMessage
            ? err.data.messages[0].message || options.failureText
            : options.failureText;

          this.modify(notification, failureText, {
            type: 'error',
            length: 4,
          });
          return $q.reject(err);
        });
    }
  }

  Object.assign(Notifications.prototype, {
    notifications: [],
  });

  return new Notifications();
};

module.exports = angular
  .module('bench.data.service.notifications', deps)
  .factory('NotificationsService', factory);
